module.exports = __webpack_public_path__ + "img/SiteTree.3d4b600c.svg";